import React, { useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { Button, TextField, Paper } from '@mui/material';
import { ScreenFrame, ConfirmDialog } from '../PrototypeShared';

export default function ProductionRecipeFormScreen() {
  const { id } = useParams();
  const navigate = useNavigate();
  const isNew = !id;
  const [saveModal, setSaveModal] = useState(false);

  const handleSaveConfirm = () => {
    setSaveModal(false);
    navigate(isNew ? '/prototype/production-recipes' : `/prototype/production-recipes/${id}`);
  };

  return (
    <ScreenFrame
      title={isNew ? 'New production recipe' : `Recipe ${id}`}
      actions={
        <>
          <Button component={Link} to="/prototype/production-recipes" variant="outlined" size="small">Back to list</Button>
          <Button variant="contained" size="small" onClick={() => setSaveModal(true)}>Save</Button>
        </>
      }
    >
      <Paper sx={{ p: 2, maxWidth: 500 }}>
        <TextField fullWidth label="Internal lot number" margin="normal" defaultValue={id || ''} />
        <TextField fullWidth label="Product" margin="normal" />
      </Paper>
      <ConfirmDialog open={saveModal} title="Save recipe" message="Save this production recipe?" onConfirm={handleSaveConfirm} onCancel={() => setSaveModal(false)} />
    </ScreenFrame>
  );
}
